module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "6"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "mt-1 mr-2"
  }, [_vm._v("Reverse && Expense")])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.getExpInvList.length) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    class: ' ml-4' + _vm.visible ? null : 'collapsed',
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": _vm.Filter.dateRange.startDate || _vm.Filter.dateRange.endDate ?
        'outline-danger' :
        'outline-primary',
      "aria-expanded": _vm.visible ? 'true' : 'false',
      "aria-controls": "collapse-4"
    },
    on: {
      "click": function($event) {
        _vm.visible = !_vm.visible
      }
    }
  }, [_vm._v(_vm._s(_vm.Filter.dateRange.startDate || _vm.Filter.dateRange.endDate ?
    "Filter ON" :
    "Filter OFF"))]), _vm._v(" "), (_vm.getExpInvList.length > 0) ? _c('b-button', {
    staticClass: "pull-right ml-1 mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.exportInvExpSaleReport('getExpInvList', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Tot. Inv = " + _vm._s(_vm.getInvListCount))])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Tot. Exp = " + _vm._s(_vm.getExpListCount))])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('label', [_vm._v("Tot. Both = " + _vm._s(_vm.getExpInvListCount))])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('div', [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.getExpInvList.length,
      "per-page": _vm.pagination.perPage
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])], 1), _vm._v(" "), (_vm.visible) ? _c('div', [_c('b-card', [_c('b-collapse', {
    attrs: {
      "id": "collapse-2"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.Filter.DFlag ? true : false
    },
    on: {
      "update": function($event) {
        _vm.getInvExpSale('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "dateRange", $$v)
      },
      expression: "Filter.dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Common Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Common Filter",
      "id": "commonFilter",
      "name": "commonFilter"
    },
    on: {
      "input": function($event) {
        _vm.getInvExpSale('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.commonFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "commonFilter", $$v)
      },
      expression: "Filter.commonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Invoice Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Invoice Filter",
      "id": "invFilter",
      "name": "invFilter"
    },
    on: {
      "input": function($event) {
        _vm.getInvExpSale('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.invFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "invFilter", $$v)
      },
      expression: "Filter.invFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Job No Filter")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Job No Filter",
      "id": "jobFilter",
      "name": "jobFilter"
    },
    on: {
      "input": function($event) {
        _vm.getInvExpSale('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.Filter.jobFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "jobFilter", $$v)
      },
      expression: "Filter.jobFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "ml-1 pull-right",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "table-background position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "fields": _vm.getExpInvFields,
      "items": _vm.getExpInvList,
      "per-page": _vm.pagination.perPage,
      "current-page": _vm.pagination.currentPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "JOBNO",
      fn: function(row1) {
        return [_c('span', [_vm._v("JOB NO : " + _vm._s(row1.item.JOBNO))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("JOB Date : " + _vm._s(row1.item.JOBDate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("JOB Type : " + _vm._s(row1.item.JOBTYPE))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Booking No : " + _vm._s(row1.item.validBookingNo))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Client : " + _vm._s(row1.item.clientName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Sline : " + _vm._s(row1.item.shippingLine))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.RaisedFrom))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised By : " + _vm._s(row1.item.RaisedBy))]), _vm._v(" "), (
          _vm.$sessionsStorage.get('is_Mobile') != 'port' &&
          row1.item.inv_module_id
        ) ? _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "assign_date": row1.item.JOBDate,
            "assign_job_type": row1.item.JOBTYPE,
            "assign_raised_from": '',
            "assign_raised_by": '',
            "fk_all_module_id": row1.item.inv_module_id,
            "jb_series": row1.item.JOBNO,
            "fk_client_id": '',
            "fk_pod_id": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.inv_module_id) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row1.item.JOBNO,
            "PMC_JOBID": row1.item.inv_module_id,
            "PMC_JOBNO": row1.item.JOBNO,
            "PMC_JOBDATE": row1.item.JOBDate,
            "PMC_JOBTYPE": row1.item.JOBTYPE,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.clientName,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.inv_module_id) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row1.item.inv_module_id),
            "JobNo": row1.item.JOBNO
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.inv_module_id) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.JOBNO,
            "PMC_JOBID": row1.item.inv_module_id,
            "PMC_JOBNO": row1.item.JOBNO,
            "PMC_JOBDATE": row1.item.JOBDate,
            "PMC_JOBTYPE": row1.item.JOBTYPE,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.clientName,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.inv_module_id) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' + row1.item.JOBNO,
            "PMC_JOBID": row1.item.inv_module_id,
            "PMC_JOBNO": row1.item.JOBNO,
            "PMC_JOBDATE": row1.item.JOBDate,
            "PMC_JOBTYPE": row1.item.JOBTYPE,
            "PMC_Client": row1.item.clientName,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e()]
      }
    }, {
      key: "JOBDate",
      fn: function(row2) {
        return [_c('span', [_vm._v("FF : " + _vm._s(row2.item.FFInvStatus))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("CC : " + _vm._s(row2.item.CCInvStatus))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("TPT : " + _vm._s(row2.item.TPTInvStatus))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("CR : " + _vm._s(row2.item.OSCRSERIES))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("DR : " + _vm._s(row2.item.OSDRSERIES))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Tally INV : " + _vm._s(row2.item.tallyExistInvoice))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Inv NO : " + _vm._s(row2.item.inv_no))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Inv Date : " + _vm._s(row2.item.inv_date))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Inv Type : " + _vm._s(row2.item.inv_type))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Type : " + _vm._s(row2.item.inv_exp_type))])]
      }
    }, {
      key: "inv_item",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s(row3.item.inv_item))])]
      }
    }, {
      key: "inv_amt",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.inv_amt))])]
      }
    }, {
      key: "item_created_date",
      fn: function(row5) {
        return [_c('span', [_vm._v("Created Item Date : " + _vm._s(row5.item.item_created_date))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Updated Item Date : " + _vm._s(row5.item.item_updated_date))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.getExpInvList.length,
      "per-page": _vm.pagination.perPage
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0095e556","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ulip/OceanFreightReverseCard.vue
// module id = 2348
// module chunks = 0